import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import {
  CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter,
  CButton, CForm, CFormLabel, CFormInput, CFormTextarea, CSpinner
} from "@coreui/react";
import DatePicker from "react-datepicker";

// Событие «журнал простоев изменился»: после сохранения в любом месте страницы
// (таблица длинных простоев на дашборде, панель управления) раздел «Простои» в панели
// перезагружает список сам, без пересчета аналитики и перезагрузки страницы
export const DOWNTIME_CHANGED_EVENT = "downtime-incidents-changed";

export const notifyDowntimeChanged = (deviceId) =>
  window.dispatchEvent(new CustomEvent(DOWNTIME_CHANGED_EVENT, { detail: { deviceId } }));

const DowntimeModal = ({ visible, onClose, deviceId, initialData, onSuccess }) => {
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    reason: "",
    comment: "",
    start_time: new Date(),
    end_time: new Date()
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        id: initialData.id || null,
        reason: initialData.reason || "",
        comment: initialData.comment || "",
        start_time: initialData.start_time || new Date(),
        end_time: initialData.end_time || new Date()
      });
    } else {
      setFormData({
        id: null, reason: "", comment: "", start_time: new Date(), end_time: new Date()
      });
    }
  }, [initialData, visible]);

  const handleSave = async () => {
    if (!formData.reason.trim()) {
      toast.warn("Укажите причину простоя");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        device: deviceId,
        reason: formData.reason.trim(),
        comment: formData.comment.trim(),
        start_time: formData.start_time.toISOString(),
        end_time: formData.end_time.toISOString(),
      };

      const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };
      
      if (formData.id) {
        await axios.patch(`/api/downtime-incidents/${formData.id}/`, payload, { headers });
        toast.success("Данные о простое обновлены");
      } else {
        await axios.post("/api/downtime-incidents/", payload, { headers });
        toast.success("Простой успешно зафиксирован");
      }
      notifyDowntimeChanged(deviceId);
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      toast.error("Ошибка сохранения простоя");
    } finally {
      setSaving(false);
    }
  };

  return (
    <CModal visible={visible} onClose={onClose} alignment="center">
      <CModalHeader>
        <CModalTitle>{formData.id ? "Редактировать простой" : "Зафиксировать простой"}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm>
          <div className="mb-3">
            <CFormLabel className="fw-bold text-muted small">Диапазон времени</CFormLabel>
            <div className="d-flex gap-2">
              <DatePicker
                selected={formData.start_time}
                onChange={(d) => setFormData(p => ({ ...p, start_time: d }))}
                showTimeSelect
                dateFormat="dd.MM.yyyy HH:mm"
                className="form-control"
              />
              <DatePicker
                selected={formData.end_time}
                onChange={(d) => setFormData(p => ({ ...p, end_time: d }))}
                showTimeSelect
                dateFormat="dd.MM.yyyy HH:mm"
                className="form-control"
              />
            </div>
          </div>
          <div className="mb-3">
            <CFormLabel className="fw-bold text-muted small">Причина простоя</CFormLabel>
            <CFormInput 
              type="text"
              placeholder="Например: Поломка ковша, Обеденный перерыв..."
              value={formData.reason} 
              onChange={(e) => setFormData(p => ({ ...p, reason: e.target.value }))}
            />
          </div>
          <div className="mb-3">
            <CFormLabel className="fw-bold text-muted small">Комментарий (детали)</CFormLabel>
            <CFormTextarea
              rows={3}
              placeholder="Например: Ожидание механиков со склада..."
              value={formData.comment}
              onChange={(e) => setFormData(p => ({ ...p, comment: e.target.value }))}
            />
          </div>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose} variant="ghost">Отмена</CButton>
        <CButton color="danger" onClick={handleSave} disabled={saving} className="fw-bold">
          {saving ? <CSpinner size="sm"/> : "Сохранить"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default DowntimeModal;